import Image from 'next/image';
import { useMedia } from 'react-use';

import { StyledPrimaryCell, StyledH2 } from '@/components/CrossChainSwaps/utils';

import { SUPPORTED_CHAINS } from '@/constants/chain';

import { fontStyles } from '@/styles/typography';
import { breakpoints } from '@/styles/util';

import { CheckmarkIcon } from '@/ui/Icons/CheckmarkIcon';
import { ResponsiveBR } from '@/ui/ResponsiveBR';

const LIQUIDITY_TEXT_ITEMS = [
  'Aggregated liquidity across 100+ sources',
  `Swap across ${SUPPORTED_CHAINS.length} chains`,
  'From topping up gas to moving large positions',
  'Fast and simple cross chain swaps for all trade sizes',
];

const DEFAULT_TITLE = (
  <>
    Cross chain swaps need <ResponsiveBR /> cross chain liquidity
  </>
);

export const CrossChainLiquiditySection = ({
  title = DEFAULT_TITLE,
  listItems = LIQUIDITY_TEXT_ITEMS,
}) => {
  const isMobile = useMedia(breakpoints.mobile, false);

  return (
    <StyledPrimaryCell className="tablet:flex-row tablet:pb-15 flex flex-col justify-between pb-68">
      <div>
        <StyledH2>{title}</StyledH2>
        <ul className="text-token-gray-800 mt-4">
          {listItems.map((text) => (
            <li className="mt-4 flex items-center first:mt-0" key={text}>
              <div className="text-primitive-basic-white flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#02A863] from-[-13.93%] via-[rgba(2,168,99,0.49)] via-[112.7%] shadow-[0px_1px_3px_rgba(0,0,0,0.12),inset_0px_-1px_0px_rgba(0,0,0,0.16)]">
                <CheckmarkIcon />
              </div>
              <span
                className={fontStyles({
                  variant: 'BODY_LG',
                  className: 'text-token-gray-800 ml-3',
                })}
              >
                {text}
              </span>
            </li>
          ))}
        </ul>
      </div>
      <div className="tablet:mt-0 mt-12 flex items-center justify-center">
        <Image
          width={isMobile ? 311 : 353}
          height={isMobile ? 227 : 208}
          alt="Liquidity funnel logo"
          src="/images/crosschain/funnel.svg"
          style={{ maxWidth: '100%' }}
        />
      </div>
    </StyledPrimaryCell>
  );
};
